__turbopack_context__.v({
  "active": "style-module-scss-module__N_TkNW__active",
  "address-page-icon": "style-module-scss-module__N_TkNW__address-page-icon",
  "component": "style-module-scss-module__N_TkNW__component",
  "dash": "style-module-scss-module__N_TkNW__dash",
  "dash-check": "style-module-scss-module__N_TkNW__dash-check",
  "exp": "style-module-scss-module__N_TkNW__exp",
  "favourite": "style-module-scss-module__N_TkNW__favourite",
  "favourite-wrapper": "style-module-scss-module__N_TkNW__favourite-wrapper",
  "fillWhite": "style-module-scss-module__N_TkNW__fillWhite",
  "icon-spin": "style-module-scss-module__N_TkNW__icon-spin",
  "inline": "style-module-scss-module__N_TkNW__inline",
  "pride": "style-module-scss-module__N_TkNW__pride",
  "progressBarStripes": "style-module-scss-module__N_TkNW__progressBarStripes",
  "pulsateScale": "style-module-scss-module__N_TkNW__pulsateScale",
  "shimmer": "style-module-scss-module__N_TkNW__shimmer",
  "small-card": "style-module-scss-module__N_TkNW__small-card",
  "smallPulsateScale": "style-module-scss-module__N_TkNW__smallPulsateScale",
  "spin": "style-module-scss-module__N_TkNW__spin",
});
